export const API_HOST = process.env.API_HOST || '/backend';
export const API_HOST_DOMAIN = process.env.NEXT_PUBLIC_API_HOST_DOMAIN;
export const API_CHAT_DOMAIN = process.env.NEXT_PUBLIC_API_CHAT_DOMAIN;
export const API_PRD_HOST_DOMAIN = process.env.NEXT_PUBLIC_API_PRD_HOST_DOMAIN;
// export const API_HOST = 'https://v2api.thuocsi.vn/';
export const MOCK_API_HOST = process.env.MOCK_API_HOST || '/api';
export const BASIC_AUTHEN = process.env.NEXT_PUBLIC_BASIC_AUTHEN || '';
export const DOMAIN_SELLER_CENTER = process.env.NEXT_PUBLIC_DOMAIN_SELLER_CENTER || '';
export const FACEBOOK_MESSENGER_ID = process.env.NEXT_PUBLIC_FACEBOOK_MESSENGER_ID || '';
// export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_MESSENGER_ID || '';
export const FACEBOOK_APP_ID = 1074695020285628;
// export const DISCOVERY_URL = process.env.NEXT_PUBLIC_DISCOVERY || ''; // deprecated 22Feb2023 - Dinh Tran
// export const WEB_HOST = process.env.WEB_HOST || '';
// export const NEXT_I18NEXT_NAME_SPACES = ['common', 'apiErrors']; // deprecated 22Feb2023 - Dinh Tran
export const DOMAIN_TS = process.env.NEXT_PUBLIC_DOMAIN_TS || '';
// export const DOMAIN_TS_MIEN_BAC = process.env.NEXT_PUBLIC_DOMAIN_TS_MIEN_BAC || ''; // deprecated 22Feb2023 - Dinh Tran
export const ENV = process.env.NEXT_PUBLIC_ENV || 'stg';
export const GG_IMAGE = process.env.NEXT_PUBLIC_DOMAIN_GG_IMAGE || 'https://storage.googleapis.com';
// Host GCS proxy dùng chung cho mọi link ảnh/file (đứng trước storage.googleapis.com).
// Đây là single source: các biến legacy bên dưới (PROXY_IMAGE, GCS_IMAGE, DOMAIN_IMAGE_CACHE_LOADER)
// nếu không set riêng trong env sẽ tự quy về GCS_HOST.
export const GCS_HOST = process.env.NEXT_PUBLIC_DOMAIN_GCS || 'https://gcs-global.buymed.com';
export const PROXY_IMAGE = process.env.NEXT_PUBLIC_DOMAIN_PROXY_IMAGE || GCS_HOST;
export const GCS_IMAGE = process.env.NEXT_PUBLIC_DOMAIN_GCS_IMAGE || GCS_HOST;
export const CDN_GCS = process.env.NEXT_PUBLIC_DOMAIN_CDN_GCS || '';
export const CDN_PROXY_IMAGE =
  process.env.NEXT_PUBLIC_DOMAIN_CDN_PROXY_IMAGE || 'https://cdn-th-img-proxy.buymed.tech';
export const isPrd = ENV === 'prd';
export const LINK_LICENSE =
  process.env.NEXT_PUBLIC_LINK_LICENSE ||
  'https://buymedv1prdgcpbackup.blob.core.windows.net/buymed-storage/trading_license/1.%20Trading%20License%20-%20Buymed%20(GC%2020%20June%202019)%20(VN).pdf?sv=2020-08-04&ss=bqtf&srt=sco&sp=rwdlacuptfxi&se=2021-08-27T12:47:55Z&sig=EpT7zqi%2BHnb%2F07cVHPnazba9vkWuZbAP42dcbDITOCU%3D&_=1630039704966';

export const INSIDER_ID = process.env.NEXT_PUBLIC_INSIDER_ID;
export const INSIDER_SCRIPT_DOMAIN = process.env.NEXT_PUBLIC_INSIDER_SCRIPT_DOMAIN || '';
export const INSIDER_API_DOMAIN = process.env.NEXT_PUBLIC_INSIDER_API_DOMAIN;
export const SHOW_INSIDER_RECOMMEND = process.env.NEXT_PUBLIC_SHOW_INSIDER_RECOMMEND === 'on';
export const THUOCSI_DOMAIN = '/';
export const DOMAIN_FEEDBACK = process.env.NEXT_PUBLIC_DOMAIN_FEEDBACK || '';
export const FACEBOOK_PIXEL_CODE = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_CODE || ''; // deprecated 22Feb2023 - Dinh Tran

export const PROVINCES_TURN_OFF_PAYMENT =
  process.env.NEXT_PUBLIC_FEATURE_PROVINCE_TURNOFF_PAYMENT || [];
// export const PROVINCES_DELAY_DELIVERY = process.env.NEXT_PUBLIC_FEATURE_PROVINCE_DELAY_DELIVERY || []; // deprecated 22Feb2023 - Dinh Tran
export const NOTIFY_IN_TOP_BAR = process.env.NEXT_PUBLIC_FEATURE_NOTI_TOPBAR || '';
export const NOTIFY_IN_TOP_BAR_UIV2 = process.env.NEXT_PUBLIC_FEATURE_NOTI_TOPBAR_UIV2 || '';
export const MAX_SKU_IN_ORDER = process.env.NEXT_PUBLIC_FEATURE_MAX_SKU_IN_ORDER || 0;
export const MAX_ORDER_IN_WEEK = process.env.NEXT_PUBLIC_FEATURE_MAX_ORDER_IN_WEEK || 0;

/// Feature on off here
export const FEATURE_WISHLIST =
  !process.env.NEXT_PUBLIC_FEATURE_WISHLIST || process.env.NEXT_PUBLIC_FEATURE_WISHLIST === 'on';
export const FEATURE_RE_ORDER =
  !process.env.NEXT_PUBLIC_FEATURE_RE_ORDER || process.env.NEXT_PUBLIC_FEATURE_RE_ORDER === 'on';
export const FEATURE_LEVEL =
  !process.env.NEXT_PUBLIC_FEATURE_LEVEL || process.env.NEXT_PUBLIC_FEATURE_LEVEL === 'on';
export const FEATURE_BANK_ACCOUNT =
  !process.env.NEXT_PUBLIC_FEATURE_BANK_ACCOUNT ||
  process.env.NEXT_PUBLIC_FEATURE_BANK_ACCOUNT === 'on';
export const SELLER_CODES_REQUIRE_GPP = process.env.NEXT_PUBLIC_SELLER_CODES_REQUIRE_GPP || [];
export const FEATURE_STORE =
  !process.env.NEXT_PUBLIC_FEATURE_STORE || process.env.NEXT_PUBLIC_FEATURE_STORE === 'on';
/// QR CODE
export const QR_CODE_DOMAIN = process.env.NEXT_PUBLIC_QR_CODE_DOMAIN;

export const TTL_CACHE_LOCAL = process.env.NEXT_PUBLIC_TTL_CACHE_LOCAL;
export const TTL_CACHE_SERVER = process.env.NEXT_PUBLIC_TTL_CACHE_SERVER || 900;

export const LIKE_FEEDBACK_CODE = process.env.NEXT_PUBLIC_LIKE_FEEDBACK_CODE || '';
export const DISLIKE_FEEDBACK_CODE = process.env.NEXT_PUBLIC_DISLIKE_FEEDBACK_CODE || '';
export const TIME_PREVENT_FEEDBACK_PRICE =
  process.env.NEXT_PUBLIC_TIME_PREVENT_FEEDBACK_PRICE || 1000;

// tag new
export const TAG_NEW = process.env.NEXT_PUBLIC_TAG_NEW || '';
export const TAG_PRODUCT_NEAR_EXPIRED = process.env.NEXT_PUBLIC_TAG_PRODUCT_NEAR_EXPIRE || '';
// btn return order at /my-order
export const RETURN_ORDER_DOMAIN = process.env.NEXT_PUBLIC_DOMAIN_POS || '';
export const RETURN_ORDER_DOMAIN_TICKETID = process.env.NEXT_PUBLIC_DOMAIN_POS_TICKETID || '';
// tag 7 ngay
export const TAG_7DAYS = process.env.NEXT_PUBLIC_TAG_7DAY || '';
export const REGION_MB = process.env.NEXT_PUBLIC_MIENBAC_REGIONCODE || '';

export const GTM = process.env.NEXT_PUBLIC_GTM || '';
export const GTM_NEW = process.env.NEXT_PUBLIC_GTM_NEW || '';

// MAAC (Crescendo Lab) Web SDK — clWebChannelId. Rỗng = không load SDK, không bắn event.
export const MAAC_CHANNEL_ID = process.env.NEXT_PUBLIC_MAAC_CHANNEL_ID || '';

export const DOMAIN_FLAGSHIP_STORE = process.env.NEXT_PUBLIC_WEB_SELLER_FLAGSHIP_STORE || '';
export const GENERAL_DOMAIN = process.env.NEXT_PUBLIC_GENERAL_DOMAIN || '';
export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN || '';
export const WEB_HOST = process.env.NEXT_PUBLIC_WEB_HOST || '';
export const DOMAIN_WEB_HOST = process.env.NEXT_PUBLIC_DOMAIN_WEB_HOST || '';

export const ACCESS_TOKEN = process.env.NEXT_PUBLIC_ACCESS_TOKEN || 'ts_auth_access_token_v2';
export const ACCESS_TOKEN_LONGLIVE =
  process.env.NEXT_PUBLIC_ACCESS_TOKEN_LONG_LIVE || 'ts_auth_access_token_longlive_v2';

export const MAX_ITEM_IN_CART = process.env.NEXT_PUBLIC_MAX_ITEM_IN_CART || 200;
export const FEATURE_SHOW_BUTTON_VERIFY_CART =
  !process.env.NEXT_PUBLIC_FEATURE_SHOW_BUTTON_VERIFY_CART ||
  process.env.NEXT_PUBLIC_FEATURE_SHOW_BUTTON_VERIFY_CART === 'on';

export const TAG_HANG_DAT_TRUOC = 'HANG_DAT_TRUOC';

export const BOT_TELE_ORDER_TOKEN = process.env.NEXT_PUBLIC_BOT_TELE_ORDER_ALERT || null;
export const BOT_TELE_CHANNEL_ID = process.env.NEXT_PUBLIC_TELE_CHANNEL_ID || '-1001988270354';
export const BOT_TELE_THREAD_ID = process.env.NEXT_PUBLIC_TELE_THREAD_ORDER || '32';

export const DOMAIN_IMAGE_CACHE_LOADER = process.env.NEXT_PUBLIC_LOADER_IMAGE || GCS_HOST;

export const REASON_CANCEL_ORDER = process.env.NEXT_PUBLIC_REASON_CANCEL_ORDER || '';
export const REASON_VOUCHER_BIRTHDAY = process.env.NEXT_PUBLIC_VOUCHER_BIRTHDAY_CODE || '';

// Image
export const PROVINCES_IMAGE_FULL_WIDTH = process.env.NEXT_PUBLIC_PROVINCES_IMAGE_FULL_WIDTH || [];
// export const IS_USE_FULL_WIDTH_ALL = PROVINCES_IMAGE_FULL_WIDTH?.includes('00'); // deprecated 22Feb2023 - Dinh Tran
export const FEATURE_CHAT = process.env.NEXT_PUBLIC_FEATURE_CHAT === 'on' || false;

// web service apis
export const IS_WEB_SERVICE = process.env.NEXT_PUBLIC_WEB_SERVICE === 'on';
export const IS_WEB_SERVICE_SEARCH_LITE = process.env.NEXT_PUBLIC_WEB_SERVICE_SEARCH_LITE === 'on';

// CONFIG COUNTRY
const mapConfigCurrency = {
  vn: 'đ',
  cam: '$',
  kh: '$',
  th: '฿',
  en: '$',
  default: '$',
};

const mapConfigSeperate = {
  vn: '.',
  cam: '$&,',
  default: '$&,',
  kh: '$&,',
  th: ',',
};

const mapConfigSetPrefix = {
  vn: false,
  cam: false,
  th: true,
  en: false,
  default: false,
};

// translate text limit order
export const mapLimitOrderDay = {
  vn: 'Đặt tối đa {quantity} {unit}/ngày',
  en: 'Buy maximum {quantity} {unit}/day',
  default: 'Buy maximum {quantity} {unit}/day',
  kh: 'កំណត់ {quantity} អតិបរមា {unit}/ថ្ងៃ',
  cam: 'កំណត់ {quantity} អតិបរមា {unit}/ថ្ងៃ',
  th: 'ซื้อสูงสุด {quantity} {unit}/วัน',
};

export const mapLimitOrderTime = {
  vn: 'Đặt tối đa {quantity} {unit}/lần',
  en: 'Buy maximum {quantity} {unit}/order',
  default: 'Buy maximum {quantity} {unit}/order',
  cam: 'ទិញអតិបរមា {quantity} {unit}/មួយដង',
  kh: 'ទិញអតិបរមា {quantity} {unit}/មួយដង',
  th: 'ซื้อสูงสุด {quantity} {unit}/คำสั่ง',
};
export const mapAndLimit = {
  vn: 'và {quantity} {unit}/lần',
  en: 'and maximum {quantity} {unit}/order',
  default: 'and maximum {quantity} {unit}/order',
  th: 'และสูงสุด {quantity} {unit}/คำสั่ง',
  cam: 'និងអតិបរមា {quantity} {unit}/មួយដង',
  kh: 'និងអតិបរមា {quantity} {unit}/មួយដង',
};

export const mapDefaultValue = {
  unit: { default: 'product', vn: 'sản phẩm' },
};

export const ENV_COUNTRY = process.env.NEXT_PUBLIC_COUNTRY || 'th';
export const LANG_DEFAULT = process.env.NEXT_PUBLIC_LANG_DEFAULT || 'th';

export const messageLimitOrderDay = mapLimitOrderDay[ENV_COUNTRY] || mapLimitOrderDay.en;
export const messageLimitOrderTime = mapLimitOrderTime[ENV_COUNTRY] || mapLimitOrderTime.en;
export const messageAndLimit = mapAndLimit[ENV_COUNTRY] || mapAndLimit.en;

// currency
export const CURRENCY = mapConfigCurrency[ENV_COUNTRY] || mapConfigCurrency.en;
export const CURRENCY_SEPARATE = mapConfigSeperate[ENV_COUNTRY] || mapConfigSeperate.en;
export const CURRENCY_PREFIX = mapConfigSetPrefix[ENV_COUNTRY] || mapConfigSetPrefix.en;

// country
// ao-1409: new logo
export const NEW_MISSING_IMAGE =
  process.env.NEXT_PUBLIC_MISSING_LOGO ||
  `${GCS_HOST}/thuocsi-live/web/static/images/new-missing-logo.svg`;

export const HOTLINE = process.env.NEXT_PUBLIC_HOTLINE || '02873008840';
export const HOTLINE_TEXT = process.env.NEXT_PUBLIC_HOTLINE_TEXT || '028 7300 8840';
export const LINE_OA = process.env.NEXT_PUBLIC_LINE_OA || 'https://lin.ee/xWjviZO2';

// cdn
export const DOMAIN_CDN = process.env.NEXT_PUBLIC_CDN || '';

const languageDefault = 'en';

export const CONFIG_GLOBAL = {
  COUNTRY: ENV_COUNTRY,
  UNIT: mapDefaultValue.unit[ENV_COUNTRY] || mapDefaultValue.unit.default,
  LANG: process.env.NEXT_PUBLIC_LANG_DEFAULT || languageDefault,
  messageLimitOrderDay: mapLimitOrderDay[ENV_COUNTRY] || mapLimitOrderDay.default,
  messageLimitOrderTime: mapLimitOrderTime[ENV_COUNTRY] || mapLimitOrderTime.default,
  messageAndLimit: mapAndLimit[ENV_COUNTRY] || mapAndLimit.default,
  CURRENCY: mapConfigCurrency[ENV_COUNTRY] || mapConfigCurrency.default,
  CURRENCY_SEPARATE: mapConfigSeperate[ENV_COUNTRY] || mapConfigSeperate.default,
  HOTLINE,
  HOTLINE_TEXT,
  BRAND_NAME: 'BuyMed',
  BRAND_NAME_LONG: 'Buymed Siam',
};

export const FDA_REGISTED_CODE = process.env.NEXT_PUBLIC_FDA_RESTRICTED_CODE || '';

export const APP_CONFIG_CODE = process.env.NEXT_PUBLIC_APP_CONFIG_CODE || '';

// insider marcom
export const MARCOM_API_DOMAIN = process.env.NEXT_PUBLIC_MARCOM_API_DOMAIN || '';
export const FIREBASE_API_KEY = process.env.NEXT_PUBLIC_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = process.env.NEXT_PUBLIC_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID = process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID;
export const FIREBASE_VAPID_KEY = process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY;
export const FIREBASE_SW_PATH = `${process.env.NEXT_PUBLIC_DOMAIN_TS}/firebase-messaging-sw.js`;
export const URL_INSIDER_POPUP = process.env.NEXT_PUBLIC_URL_INSIDER_POPUP || '';
export const PROJECT_ID = process.env.NEXT_PUBLIC_PROJECT_ID || '';

export const RECAPTCHA_SITE_KEY = '6Lf23CQqAAAAACGGoN1UjueHpIUgn6DcqqSxz37c';

export const CLARITY_KEY = process.env.NEXT_PUBLIC_CLARITY_KEY || '';
